import { z } from "zod";

const ZodTime = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/);

/**
 * Business hours: one entry per weekday the office is open — Monday-first `weekday`, opening and
 * closing as `HH:mm` German time. A weekday missing from the list is closed; null takes the next
 * level's hours (a workspace the organisation's, the organisation Monday to Friday 07:00–17:00).
 */
export const businessHoursSchema = z
	.array(
		z
			.object({ weekday: z.number().int().min(0).max(6), startsAt: ZodTime, endsAt: ZodTime })
			.refine((day) => day.startsAt < day.endsAt, { path: ["endsAt"] }),
	)
	.refine((days) => new Set(days.map((day) => day.weekday)).size === days.length)
	.nullable();

export type BusinessHoursSchema = z.infer<typeof businessHoursSchema>;

/** The organisation's business hours, as its settings save them. */
export const patchOrganizationBusinessHoursSchema = z.object({
	businessHours: businessHoursSchema,
});

export type PatchOrganizationBusinessHoursSchema = z.infer<
	typeof patchOrganizationBusinessHoursSchema
>;
